import { Box, Flex, Text, AspectRatio, SimpleGrid } from '@chakra-ui/react'
import Image from 'next/image'
import { COLOR } from './'
import Link from 'next/link'
import { Link as ScrollLink } from 'react-scroll'

interface MapPinIconProps {
  w?: object | string
  h?: string
}

const MapPinIcon: React.FC<MapPinIconProps> = ({ w, h }) => {
  return (
    <Box w={w || '24px'} h={h || '100%'}>
      <Image
        src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/PM-1737264658777.png"
        alt="map pin"
        width={24}
        height={30}
        className="w-full h-full object-cover"
      />
    </Box>
  )
}

const WatsonOutlets = [
  {
    location: 'Watsons - Central',
    stores: [
      'Anchorpoint Shopping Centre #01-26/27',
      'Ang Mo Kio Hub #B1-29',
      'Aperia Mall #01-07',
      'Bugis Junction #02-29',
      'Chinatown Point #B1-28/29',
      'City Square Mall #B1-11',
      'Forum Galleria #B1-20/21',
      'Funan #B1-07',
      'Great World City #B1-118 to 121',
      'International Plaza #01-62 to 67',
      'Ion Orchard #B4-12',
      'Junction 8 Shopping #02-45/46',
      'Marina Bay Financial Centre #B2-57/58/59',
      'Marina Square #02-212',
      'Ngee Ann City #B2-06 to 10',
      'Novena Square #02-05/09',
      "People's Park Complex #01-37/38",
      'Raffles City #B1-42',
      'The Centrepoint #01-32/33B',
      'Suntec City Mall (T5 West Wing) #02-420',
      'The Poiz Centre #01-55/56/57',
      'The Shoppes At Marina Bay Sands #B2-01B',
      'Tiong Bahru Plaza #01-131/132',
      'Toa Payoh (HDB) #01-510',
      'United Square #B1-53'
    ]
  },
  {
    location: 'Watsons - North East',
    stores: [
      'Compass One #02-09',
      'Hougang Mall #03-02',
      'Hougang Street 21 #02-16',
      'Pasir Ris Mall #B1-19',
      'Rivervale Mall #02-13/14',
      'Sengkang Grand Mall #01-44',
      'Tampines 1 #02-24',
      'Tampines Mall #B1-07/08/09',
      'Waterway Point (East Wing) #B1-31/32',
      'Whitesands #B1-01'
    ]
  },
  {
    location: 'Watsons - North West',
    stores: [
      'Bukit Panjang Plaza #01-30/31',
      'Causeway Point #B1-14/15',
      'Hillion Mall #B2-61/62/63',
      'Northpoint City (South Wing) #B1-160 to 165',
      'Sembawang Shopping Centre #01-12',
      'Sun Plaza #B1-17/18',
      'Yew Tee Point #B1-14/15'
    ]
  },
  {
    location: 'Watsons - South East',
    stores: [
      'Bedok Mall #B2-12/13',
      'Changi City Point #B1-14/15',
      'Eastpoint #02-07/08/09',
      'Heartbeat @ Bedok #01-09/10',
      'Jewel Changi Airport #B2-217/218',
      'NEX #02-57',
      'Parkway Parade #B1-14 to 16',
      'Paya Lebar Quarters #02-19',
      'Singapore Post Centre #B1-137/138'
    ]
  },
  {
    location: 'Watsons - South West',
    stores: [
      'Beauty World Centre #B1-11/12',
      'Choa Chu Kang Lot 1 #02-07',
      'Clementi Mall #B1-37/38/39',
      'Harbour Front Centre #01-56/57',
      'Imm Building #01-54/55',
      'JEM #B1-07',
      'Jurong Point #03-79',
      'Jurong Point #B1-12/13/14',
      'Jurong West #01-241',
      'The Star Vista #B1-23',
      'VivoCity #B2-15/16/17',
      'West Coast Plaza #B1-15/16',
      'West Mall #02-26/27',
      'Westgate #B1-15'
    ]
  }
]

const SocialMedia = () => {
  return (
    <Box px={{ base: '16px', md: '50px' }} py={{ base: '50px', md: '100px' }}>
      <Flex
        h="100%"
        direction="column"
        alignItems="center"
        justifyContent="center"
        gap={{ base: '20px', md: '40px' }}
      >
        <Flex direction="column" alignItems="center" className="w-full">
          <Text
            color={COLOR.YELLOW}
            fontWeight="bold"
            className="text-[28px] sm:text-[35px] md:text-[50px]"
            textAlign="center"
          >
            Participating Outlets
          </Text>
          <Box className="h-full w-4/5 md:w-[650px]">
            <Image
              src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/PM-1737258597595.png"
              alt="decorator"
              width={400}
              height={30}
              className="w-full h-full object-cover"
            />
          </Box>
        </Flex>

        <Flex direction="column" gap={{ base: '16px', md: '8px' }}>
          {/* Responsive Flex row, wrap on smaller screens */}
          <Flex
            justifyContent="center"
            alignItems="center"
            gap={{ base: '16px', md: '8px' }}
            wrap="wrap"
            position="relative"
            direction={{ base: 'column', md: 'row' }}
          >
            <Box
              position="absolute"
              top={{ base: '-10px', md: '-20px' }}
              left={{ base: '-20px', sm: '-40px', md: '-60px' }}
              pointerEvents={'none'}
              className="hidden md:block"
            >
              <Box w={{ base: '80px', sm: '100px', md: '160px' }} h="100%">
                <AspectRatio ratio={47 / 21} w="100%" position="relative">
                  <Image
                    src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/PM-1737267646906-transformed-1737599958169.png"
                    alt="decorator"
                    fill
                  />
                </AspectRatio>
              </Box>
            </Box>
            <Box
              w={{
                base: '80%',
                md: '146px'
              }}
              h="100%"
            >
              <ScrollLink
                to="watson"
                smooth={true}
                duration={500}
                offset={-180} // Adjusted for header height
              >
                <AspectRatio
                  ratio={103 / 63}
                  w={{
                    base: '100%',
                    sm: '100%',
                    md: '100%',
                    lg: '100%',
                    xl: '100%'
                  }}
                  position="relative"
                >
                  <Image
                    src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/logo-watson-1740936077429.png"
                    alt="decorator"
                    fill
                  />
                </AspectRatio>
              </ScrollLink>
            </Box>
            <Box
              w={{
                base: '80%',
                md: '146px'
              }}
              h="100%"
            >
              <AspectRatio
                ratio={103 / 63}
                w={{
                  base: '100%',
                  sm: '100%',
                  md: '100%',
                  lg: '100%',
                  xl: '100%'
                }}
                position="relative"
              >
                <Image
                  src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/a1-1737453056570-transformed-1737599566005.jpeg"
                  alt="decorator"
                  fill
                />
              </AspectRatio>
            </Box>
            <Box
              w={{
                base: '80%',
                md: '146px'
              }}
              h="100%"
            >
              <AspectRatio
                ratio={103 / 63}
                w={{
                  base: '100%',
                  sm: '100%',
                  md: '100%',
                  lg: '100%',
                  xl: '100%'
                }}
                position="relative"
              >
                <Image
                  src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/a2-1737453056571-transformed-1737599566007.jpeg"
                  alt="decorator"
                  fill
                />
              </AspectRatio>
            </Box>
          </Flex>

          <Flex
            gap={{ base: '16px', md: '8px' }}
            wrap="wrap"
            justifyContent="center"
            alignItems="center"
            direction={{ base: 'column', md: 'row' }}
          >
            <Link
              className="h-full w-4/5 md:w-[146px]"
              target="_blank"
              rel="noopener noreferrer"
              href="https://shp.ee/4amh2gr"
            >
              <AspectRatio
                ratio={103 / 63}
                w={{
                  base: '100%',
                  sm: '100%',
                  md: '100%',
                  lg: '100%',
                  xl: '100%'
                }}
                position="relative"
              >
                <Image
                  src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/a3-1737453056572-transformed-1737599566007.jpeg"
                  alt="decorator"
                  fill
                />
              </AspectRatio>
            </Link>

            <Link
              className="h-full w-4/5 md:w-[146px]"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.lazada.sg/shop/jml/custom-1734593465437.htm?wh_weex=true"
            >
              <AspectRatio
                ratio={103 / 63}
                w={{
                  base: '100%',
                  sm: '100%',
                  md: '100%',
                  lg: '100%',
                  xl: '100%'
                }}
                position="relative"
              >
                <Image
                  src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/a4-1737453056572-transformed-1737599566008.jpeg"
                  alt="decorator"
                  fill
                />
              </AspectRatio>
            </Link>

            <Link
              className="h-full w-4/5 md:w-[146px]"
              target="_blank"
              rel="noopener noreferrer"
              href="https://habbit.sg/products/zero2one-hair-tonic-by-ellixi-plus"
            >
              <AspectRatio
                ratio={103 / 63}
                w={{
                  base: '100%',
                  sm: '100%',
                  md: '100%',
                  lg: '100%',
                  xl: '100%'
                }}
                position="relative"
              >
                <Image
                  src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/a5-1737453056572-transformed-1737599566008.jpeg"
                  alt="decorator"
                  fill
                />
              </AspectRatio>
            </Link>
            <Box
              w={{
                base: '80%',
                md: '146px'
              }}
              h="100%"
            >
              <AspectRatio
                ratio={103 / 63}
                w={{
                  base: '100%',
                  sm: '100%',
                  md: '100%',
                  lg: '100%',
                  xl: '100%'
                }}
                position="relative"
              >
                <Image
                  src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/a6-1737453056573-transformed-1737599566008.jpeg"
                  alt="decorator"
                  fill
                />
              </AspectRatio>
            </Box>
          </Flex>

          {/* JML Experience Store */}
          <Flex direction="column" gap="8px" mt="40px">
            <Text color={COLOR.YELLOW} className="text-[26px] font-extrabold">
              JML Experience Store
            </Text>

            <Flex direction={{ base: 'column', md: 'row' }} gap="20px">
              <Flex
                gap="8px"
                alignItems="center"
                w={{ base: '100%', md: '50%' }}
              >
                <MapPinIcon w={{ base: '12px', md: '18px' }} />
                <Text color={COLOR.LIGHT} className="text-[12px] md:text-base">
                  Causeway Point #03-19
                </Text>
              </Flex>
            </Flex>
          </Flex>

          {/* OG */}
          <Flex direction="column" gap="8px" mt="40px">
            <Text color={COLOR.YELLOW} className="text-[26px] font-extrabold">
              OG
            </Text>

            <Flex direction={{ base: 'column', md: 'row' }} gap="20px">
              <Flex
                gap="8px"
                alignItems="center"
                w={{ base: '100%', md: '50%' }}
              >
                <MapPinIcon w={{ base: '12px', md: '18px' }} />
                <Text color={COLOR.LIGHT} className="text-[12px] md:text-base">
                  OG People Park #Level 5
                </Text>
              </Flex>
              <Flex
                gap="8px"
                alignItems="center"
                w={{ base: '100%', md: '50%' }}
              >
                <MapPinIcon w={{ base: '12px', md: '18px' }} />
                <Text color={COLOR.LIGHT} className="text-[12px] md:text-base">
                  OG Albert #Level 3
                </Text>
              </Flex>
            </Flex>
          </Flex>

          {/* Watson */}
          <Text
            color={COLOR.YELLOW}
            className="text-[26px] font-extrabold"
            mt="40px"
          >
            Watsons
          </Text>
          {WatsonOutlets.map((outlet, index) => (
            <Box key={index} w="100%" id="watson">
              <Text color={COLOR.YELLOW} className="text-[26px] font-extrabold">
                {outlet.location}
              </Text>

              <SimpleGrid
                columns={{ base: 1, sm: 2 }}
                gap={6}
                w={'100%'}
                mt={5}
              >
                {outlet.stores.map((store, index) => (
                  <Flex key={index} gap="8px" alignItems="center">
                    <MapPinIcon w={{ base: '12px', md: '18px' }} />
                    <Text
                      color={COLOR.LIGHT}
                      className="text-[12px] md:text-base"
                    >
                      {store}
                    </Text>
                  </Flex>
                ))}
              </SimpleGrid>
            </Box>
          ))}
        </Flex>
      </Flex>
    </Box>
  )
}

export default SocialMedia
